export default function CommunityCta() {
  return m('section.dc-section.dc-section--tight', m('div.dc-container', m('div.dc-cta', [m('div.dc-cta__body', [m('h2', 'Есть опыт, которым стоит поделиться?'), m('p', 'Напишите статью, ответьте на вопрос или начните новое обсуждение. Лучшие материалы попадают в подборку недели.'), m('div.dc-cta__actions', [m('a.dc-btn.dc-btn--inverted.dc-btn--lg', {
    href: '/articles'
  }, 'Создать публикацию'), m('a.dc-btn.dc-btn--outline-light.dc-btn--lg', {
    href: '/all'
  }, 'Начать обсуждение')])])])));
}
flarum.reg.add('devconnect-portal', 'forum/components/CommunityCta', CommunityCta);